// =============================
// File: src/envconfigs.js
// =============================

export const KEYCLOAK_CONFIG = {
url: "https://identity.govigilant.app",
realm: "vigilant",
clientId: "voyager2",
};


// API base + path for articles
export const API_BASE_URL = "https://staging.api.govigilant.app";
export const ARTICLES_PATH = "/api/alerts";
export const ARTICLES_PARAM_NAME = "sincePublishedAt"; // query param name to send timestamp


// Formatting: send param as UTC (Z suffix) or as local time with numeric offset (e.g. -04:00)
export const SEND_PARAM_AS_UTC = true; // set to false to send local with offset

// Timings
export const DEFAULT_LOOKBACK_MS = 5 * 60 * 1000; // last 5 minutes
export const AUTO_REFRESH_MS = 5 * 60 * 1000; // poll every 5 minutes


// SSO behavior
export const USE_SILENT_SSO = true; // set to false if you don't want check-sso iframe


// yyyy-MM-ddTHH:mm:ss.000Z (UTC)  OR  yyyy-MM-ddTHH:mm:ss.000±HH:MM (local)
export function formatTimeParam(inputMsOrDate, asUtc = SEND_PARAM_AS_UTC) {
  const d = inputMsOrDate instanceof Date ? new Date(inputMsOrDate.getTime()) : new Date(inputMsOrDate);
  if (Number.isNaN(d.getTime())) return "";
  d.setMilliseconds(0); // force .000
  const pad = (n) => String(n).padStart(2, "0");

  if (asUtc) {
    const YYYY = d.getUTCFullYear();
    const MM = pad(d.getUTCMonth() + 1);
    const DD = pad(d.getUTCDate());
    const hh = pad(d.getUTCHours());
    const mm = pad(d.getUTCMinutes());
    const ss = pad(d.getUTCSeconds());
    return `${YYYY}-${MM}-${DD}T${hh}:${mm}:${ss}.000Z`;
  } else {
    const YYYY = d.getFullYear();
    const MM = pad(d.getMonth() + 1);
    const DD = pad(d.getDate());
    const hh = pad(d.getHours());
    const mm = pad(d.getMinutes());
    const ss = pad(d.getSeconds());
    const tz = -d.getTimezoneOffset(); // minutes east of UTC
    const sign = tz >= 0 ? "+" : "-";
    const tzH = pad(Math.floor(Math.abs(tz) / 60));
    const tzM = pad(Math.abs(tz) % 60);
    return `${YYYY}-${MM}-${DD}T${hh}:${mm}:${ss}.000${sign}${tzH}:${tzM}`;
  }
}

export function buildArticlesUrl(startMsOrDate) {
  // Build the query string manually so ':' characters are NOT percent-encoded.
  // Some backends expect literal colons in ISO timestamps.
  const ts = formatTimeParam(startMsOrDate);
  return `${API_BASE_URL}${ARTICLES_PATH}?${ARTICLES_PARAM_NAME}=${ts}`;
}

